import { useLayoutEffect } from 'react';
import { PortalCreateLifecycleStage } from '../../common/types/lifecycle-handlers';
export var FormRenderSuccess = function FormRenderSuccess(_ref) {
  var lifecycleHandlers = _ref.lifecycleHandlers;
  var formRenderCompleteCallback = lifecycleHandlers[PortalCreateLifecycleStage.FormRenderComplete];
  useLayoutEffect(function () {
    formRenderCompleteCallback && formRenderCompleteCallback({
      stage: PortalCreateLifecycleStage.FormRenderComplete
    });
  }, [formRenderCompleteCallback]);
  return null;
};